import { InteractiveContainer } from "@jugl-web/ui-kit";
import { cx, useAppVariant } from "@jugl-web/utils";
import React from "react";

export const ConversationTab: React.FC<{
  isSelected: boolean;
  label: string;
  onSelect: () => void;
}> = ({ isSelected, label, onSelect }) => {
  const { isCx } = useAppVariant();

  return (
    <InteractiveContainer
      className={cx(
        "flex h-8 w-full items-center justify-center rounded-[10px] px-5 transition-colors",
        isSelected
          ? isCx
            ? "bg-dark hover:bg-black"
            : "bg-primary hover:bg-primary-600"
          : "bg-grey-100 hover:bg-grey-200"
      )}
      onClick={onSelect}
    >
      <span
        className={cx(
          "font-secondary text-[13px] leading-2 transition-colors",
          isSelected ? "font-medium text-white" : "text-dark-700"
        )}
      >
        {label}
      </span>
    </InteractiveContainer>
  );
};
